import {
  dispatchPreferenceChanged,
  readStoredEnum,
  writeStoredEnum
} from './preferenceStorage';

export type EditorOpenMode = 'inAppTab' | 'browserTab';

export const EDITOR_OPEN_MODE_KEY = 'jarvisEditorOpenMode';
export const EDITOR_OPEN_MODE_CHANGED = 'jarvis-editor-open-mode-changed';
export const DEFAULT_EDITOR_OPEN_MODE: EditorOpenMode = 'inAppTab';

const MODES: readonly EditorOpenMode[] = ['inAppTab', 'browserTab'];

export function getEditorOpenMode(): EditorOpenMode {
  return readStoredEnum(EDITOR_OPEN_MODE_KEY, MODES, DEFAULT_EDITOR_OPEN_MODE);
}

export function setEditorOpenMode(mode: EditorOpenMode): void {
  const next = MODES.includes(mode) ? mode : DEFAULT_EDITOR_OPEN_MODE;
  writeStoredEnum(EDITOR_OPEN_MODE_KEY, next);
  dispatchPreferenceChanged(EDITOR_OPEN_MODE_CHANGED, next);
}
